import React from 'react';

import SnippetEditor, {MMS_FROALA_OPTIONS} from './SnippetEditor';
import {tagEditorField} from "./snippetUtils";

const MMSSnippetEditor = (props) => (
  <SnippetEditor
    {...props}
    showFormatting={false}
    fields={[
      { displayName: 'Name', canonicalName: 'name' },
      tagEditorField
    ]}
    froalaOptions={MMS_FROALA_OPTIONS}
  />
);

export default MMSSnippetEditor;
